import { POST } from "../APiHelper/API";


export const unparkBet = (parked_bet_id, onSuccess, onError) => {
    const data = {
        parked_bet_id: parked_bet_id
    }
    POST("/api/v1/bets/unpark_bet", data, onSuccess, onError);
}